export default "__VITE_ASSET__BUpVmCX3__"